<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Geral">
        <NxInput
          name="origem"
          type="text"
          label="Nome da Origem:"
          placeholder="Digite o nome"
          @update:value="handleInputUpdate('nome', $event)"
        ></NxInput>
        <div class="form-group mt-2">
          <label>Situação:</label>
          <b-form-select
            v-model="form.inative"
            :options="situacaoOptions"
            class="form-control"
          >
            <template v-slot:first>
              <b-form-select-option :value="null">Todos</b-form-select-option>
            </template>
          </b-form-select>
        </div>
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'

export default {
  name: 'SidebarOrigem',
  components: { SidebarSearch, SearchCollapse },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        inative: null
      },
      situacaoOptions: [
        { value: 0, text: 'Ativo' },
        { value: 1, text: 'Inativo' }
      ]
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.form.nome = null
      this.form.inative = null
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '') : inputedValue
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/origem/components/search/SidebarOrigem.vue